import { gql } from '@urql/core';
import { TT_SCHEMA_FRAGMENT } from './page.query';

export const GET_SCHEMAS = gql`
  query GetSchemas(
    $ttSchemaWrapperId: Int
    $siteId: Int
    $type: TTSchemaType
    $offset: Int
    $limit: Int
    $query: String
    $visibilities: [TTSchemaVisibility!]
    $lifecycleStatus: TTEntityLifecycleStatus
  ) {
    ttSchemas(
      ttSchemaWrapperId: $ttSchemaWrapperId
      siteId: $siteId
      type: $type
      offset: $offset
      limit: $limit
      query: $query
      visibilities: $visibilities
      lifecycleStatus: $lifecycleStatus
    ) {
      items {
        id
        name
        titleSingular
        titlePlural
        type
        visibility
        deletedAt
      }
      total
    }
  }
`;

export const GET_SCHEMA = gql`
  query GetSchema($id: Int!, $includedDeleted: Boolean) {
    TTSchema(id: $id, includedDeleted: $includedDeleted) {
      id
      name
      titleSingular
      type
      ttschemaWrapper {
        id
        name
      }
    }
  }
`;

export const GET_SCHEMA_WITH_SUBSCHEMAS = gql`
  query GetTTSchemaWithSubschema($id: Int!) {
    TTSchema(id: $id) {
      ...ttschemaFragment
    }
  }
  ${TT_SCHEMA_FRAGMENT}
`;

export const CREATE_SCHEMA = gql`
  mutation CreateSchema($createTTSchemaInput: CreateTTSchemaInput!) {
    createTTSchema(createTTSchemaInput: $createTTSchemaInput) {
      id
    }
  }
`;

export const UPDATE_SCHEMA = gql`
  mutation UpdateSchema($updateTTSchemaInput: UpdateTTSchemaInput!) {
    updateTTSchema(updateTTSchemaInput: $updateTTSchemaInput) {
      id
    }
  }
`;

export const UPDATE_SCHEMA_FIELD_SORT_ORDER = gql`
  mutation UpdateSchemaFieldSortOrder(
    $updateTTSchemaFieldSortOrderInput: TTSchemaFieldSortOrderInput!
  ) {
    updateTTSchemaFieldOrder(
      updateTTSchemaFieldSortOrderInput: $updateTTSchemaFieldSortOrderInput
    ) {
      success
    }
  }
`;

export const DELETE_SCHEMA = gql`
  mutation DeleteSchema($id: Int!) {
    deleteTTSchema(id: $id) {
      success
    }
  }
`;

export const RESTORE_SCHEMA = gql`
  mutation RestoreSchema($id: Int!) {
    restoreDeletedTTSchema(id: $id) {
      id
    }
  }
`;

export const VALIDATE_SCHEMA_CREATE = gql`
  query ValidateSchemaCreate($input: ValidationInputDto!) {
    validateTTSchemaCreateDto(validationInput: $input) {
      hasErrors
      errors {
        property
        constraints
      }
    }
  }
`;

export const VALIDATE_SCHEMA_UPDATE = gql`
  query ValidateSchemaUpdate($input: ValidationInputDto!) {
    validateTTSchemaUpdateDto(validationInput: $input) {
      hasErrors
      errors {
        property
        constraints
      }
    }
  }
`;

export const CREATE_SCHEMA_BLOCK = gql`
  mutation CreateSchemaBlock {
    createSchemaBlock {
      id
    }
  }
`;

export const GENERATE_SCHEMA_BLOCK_THUMBNAIL = gql`
  mutation GenerateSchemaBlockThumbnail($blockId: Int!) {
    generateSchemaBlockThumbnail(blockId: $blockId) {
      success
    }
  }
`;

export const GENERATE_SITE_THUMBNAIL = gql`
  mutation GenerateSiteThumbnail($siteId: Int!) {
    generateSiteThumbnail(siteId: $siteId) {
      success
    }
  }
`;

export const GET_PAGE_TYPE = gql`
  query GetPageType($id: Int!) {
    TTSchema(id: $id) {
      id
      name
      titlePlural
      titleSingular
    }
  }
`;

export const GET_TTSCHEMA_USAGES = gql`
  query GetTTSchemaUsages($id: Int!, $ttSchemaWrapperId: Int!, $offset: Int, $limit: Int) {
    checkTTSchemaUsages(
      schemaId: $id
      ttSchemaWrapperId: $ttSchemaWrapperId
      offset: $offset
      limit: $limit
    ) {
      items {
        pages {
          id
          name
          parent {
            name
            urlPath
          }
          urlSegment
          site {
            id
            name
          }
          draftCustomFields {
            id
          }
          draftRevision {
            id
          }
        }
        templates {
          id
          name
          site {
            id
            name
          }
        }
        schemas {
          id
          titleSingular
          type
        }
      }
      total
    }
  }
`;
